<template>
  <!-- <button class="button-red text-sm" @click="showInfo = !showInfo">
    Hiển thị thông tin đầy đủ
  </button> -->
  <!-- <label for="jack">Hiển thị thông tin đầy đủ</label> -->
  <div class="container">
    <Switch v-model="showInfo" label="Hiển thị thông tin đầy đủ" />
    <section
      class="
        month-indicator
        bg-blue-900
        text-white text-lg
        p-2
        rounded-lg
        shadow-md
        mt-4
      "
    >
      <button class="previous" @click="previousWeek">&lt;</button>
      <span class="display">
        <span class="month"
          >{{ firstDayOfWeekPretty }} - {{ endDayOfWeekPretty }}</span
        >
      </span>
      <button class="next" @click="nextWeek">&gt;</button>
    </section>
    <section class="date-grid">
      <div class="p-2" v-for="(day, index) in weekDay" :key="index">
        <p>{{ weekDay[index] }}</p>
        <p>
          {{ format(add(firstDayOfWeek, { days: index - 1 }), "dd.MM.yyyy") }}
        </p>
      </div>
      <button
        class="bg-white dayIndividual p-2 border-gray-100"
        :class="item.booked ? 'booked' : ''"
        v-for="(item, index) in slotsInWeek"
        :key="index"
        @click="showInfo(item)"
      >
        <p>{{ item.startTime }} - {{ item.endTime }}</p>
        <div v-if="showInfo">
          <p>{{ item.data?.name }}</p>
          <p>{{ item.data?.phone }}</p>
        </div>
      </button>
    </section>
  </div>
</template>

<script>
import { format, add, sub, startOfWeek, endOfWeek, isEqual } from "date-fns";
import { vi } from "date-fns/locale";
import useFirestoreAPI from "../hooks/firestore-api";
import profiles from "../constants/profiles";
import { reactive, computed, toRefs } from "vue";
import lang from "../i18n/vi";
import Switch from "../components/Switch.vue";

export default {
  props: {
    username: String,
  },
  components: {
    Switch,
  },
  setup(props) {
    //   console.log("Events coming", props.events);
    // console.log("today", new Date());
    const firestoreAPI = useFirestoreAPI();
    // firestoreAPI.getAllEventsRealTime(
    //   props.username,
    //   data.firstDayOfWeek,
    //   data.endDayOfWeek
    // );
    // const allEventsRealTime = firestoreAPI.allEventsRealTime;
    // console.log("events", allEventsRealTime);
    const data = reactive({
      showInfo: false,
      currentDate: new Date(),
      weekView: true,
      dayView: false,
      month: computed(() => data.currentDate.getMonth()),
      year: computed(() => data.currentDate.getFullYear()),
      //   monthLanguage: lang.month[data.month + 1],
      monthLanguage: computed(() => {
        return format(data.currentDate, "MMMM yyyy", { locale: vi });
      }),
      weekDay: lang.weekDay.full,
      firstDayOfWeek: computed(() => {
        // const firstDateOfWeek = new Date(data.year, data.month, 1);
        // return firstDateOfWeek.getDay();
        return startOfWeek(data.currentDate);
      }),
      events: computed(() => {
        firestoreAPI.getEventsWithinRange(
          props.username,
          data.firstDayOfWeek,
          data.endDayOfWeek
        );
        // console.log("events within range", firestoreAPI.eventsWithinRange);
        return firestoreAPI.eventsWithinRange;
        // console.log("events", allEventsRealTime);
      }),
      firstDayOfWeekPretty: computed(() => {
        return format(data.firstDayOfWeek, "dd.MM.yyyy");
      }),
      endDayOfWeekPretty: computed(() => {
        return format(data.endDayOfWeek, "dd.MM.yyyy");
      }),
      endDayOfWeek: computed(() => {
        // const firstDateOfWeek = new Date(data.year, data.month, 1);
        // return firstDateOfWeek.getDay();
        return endOfWeek(data.currentDate);
      }),
      slotsInWeek: computed(() => {
        const slots = [];
        profiles[props.username].hourSlots.map((item, index) => {
          if (index < profiles[props.username].hourSlots.length - 1) {
            [...Array(7).keys()].map((i) => {
              const hourSlot = {};
              const _date = add(data.firstDayOfWeek, {
                days: i,
                hours: item.hour,
                minutes: item.min,
              });
              hourSlot.date = _date;
              hourSlot.startTime = format(_date, "HH:mm");
              hourSlot.endTime = format(
                add(_date, { minutes: item.duration }),
                "HH:mm"
              );
              hourSlot.name = item.name;
              hourSlot.phone = item.phone;
              // hourSlot.hour = item.hour;
              // hourSlot.min = item.min;
              const slot = findBookedSlot(_date);
              if (slot) {
                hourSlot.data = slot;
                hourSlot.booked = true;
              } else {
                hourSlot.booked = false;
              }
              slots.push(hourSlot);
            });
          }
          //   for (let i = 0; i < 7;i ++ ) {
          //       const item = {};
          //   }
        });
        return slots;
      }),
    });

    function findBookedSlot(date) {
      for (let i = 0; i < data.events.value.length; i++) {
        // if (isSameDay(allEventsRealTime.value[i].date.toDate(), date)) {
        //   return true;
        // }
        // console.log(isSameDay)
        // console.log("date", data.events.value[i].date.toDate());
        // if (
        //   allEventsRealTime.value[i].date.toDate().getTime() === date.getTime()
        // ) {
        //   return true;
        // }
        if (isEqual(data.events.value[i].date.toDate(), date)) {
          return data.events.value[i];
        }
      }
      return false;
    }

    function previousWeek() {
      data.currentDate = sub(data.currentDate, { days: 7 });
    }
    function nextWeek() {
      data.currentDate = add(data.currentDate, { days: 7 });
    }

    // function isBooked(date) {
    //   for (let i = 0; i < allEventsRealTime.value.length; i++) {
    //     // if (isSameDay(allEventsRealTime.value[i].date.toDate(), date)) {
    //     //   return true;
    //     // }
    //     // console.log(isSameDay)
    //     console.log("date", allEventsRealTime.value[i].date.toDate());
    //     // if (
    //     //   allEventsRealTime.value[i].date.toDate().getTime() === date.getTime()
    //     // ) {
    //     //   return true;
    //     // }
    //     if (isEqual(allEventsRealTime.value[i].date.toDate(), date)) {
    //       return true;
    //     }
    //   }
    //   return false;
    // }

    // const slotsInWeek = 7 * profiles[props.username].hourSlots.length;

    const removeEvent = async (eventId) => {
      if (confirm("Bạn có chắc muốn xoá termin này ko?")) {
        const message = await firestoreAPI.removeEvent(eventId);
        // const message = await removeEvent(eventId);
        console.log("meesage", message);
        return message;
      } else {
        console.log("not remove");
      }
    };

    const showInfo = (item) => {
      console.log("click", item);
      alert(item);
    };

    return {
      // upcomingEvents,
      //   allEventsRealTime,
      removeEvent,
      showInfo,
      previousWeek,
      nextWeek,
      format,
      add,
      ...toRefs(data),
    };
  },
  methods: {
    showTime(time, duration) {
      return `📋 ${format(time, "HH:mm")} - ${format(
        add(time, { minutes: duration }),
        "HH:mm"
      )}`;
    },
    showDate(time) {
      return format(time, "dd.MM.yyyy");
    },
    showLocation(location) {
      let res = "";
      switch (location) {
        case "office":
          res = "Tại văn phòng";
          break;
        case "online":
          res = "Online";
          break;
        default:
          res = location;
          break;
      }
      return res;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1100px;
  margin: 0 auto;
  .date-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);

    .dayIndividual.booked {
      //   opacity: 0.7;
      @apply bg-blue-100;
    }

    .dayIndividual {
      border-width: 1px;
    }
  }

  .month-indicator {
    display: grid;
    grid-template-columns: 49px 1fr 49px;
    grid-template-areas: "p d n";
    .previous {
      grid-area: p;
    }
    .display {
      grid-area: d;
      .month {
        text-transform: capitalize;
      }
    }
    .next {
      grid-area: n;
    }
    button:disabled {
      @apply cursor-not-allowed;
      opacity: 0.4;
    }
  }
}
</style>
